import styled from "styled-components";

import { AttachmentIcon } from "@/assets/icons";

export const StyledAttachmentIcon = styled(AttachmentIcon)`
    margin-right: 10px;
    vertical-align: text-bottom;
    width: 16px;
    height: 16px;
    path {
        fill: var(--color-secondary);
    }
`;
